import {
  AfterViewInit,
  Component,
  forwardRef,
  inject,
  Injector,
  input,
} from '@angular/core';
import {
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';
import { Dict } from '@shared/models';
import { SafePipe } from '@shared/pipes';

@Component({
  selector: 'b2c-checkbox',
  styleUrl: './checkbox.component.scss',
  templateUrl: './checkbox.component.html',
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
    },
  ],
  imports: [FormsModule, SafePipe],
})
export class CheckboxComponent implements AfterViewInit {
  label = input<string>('');
  errorMessages = input<Dict>({});
  id = input<number>(Math.random());
  serverErrorMessage = input<string>('');
  labelStyles = input<Dict | undefined>(undefined);

  public checked = false;
  public disabled = false;
  public control = new FormControl();

  private readonly injector: Injector = inject(Injector);

  ngAfterViewInit(): void {
    const ngControl = this.injector.get(NgControl, null);
    if (ngControl) {
      this.control = ngControl.control as FormControl;
    }
  }

  writeValue(checked: boolean) {
    this.checked = checked;
  }

  onModelChange(e: boolean) {
    this.checked = e;
    this.onChange(e);
  }

  onChange: (_: unknown) => void = () => ({});
  onTouch: (_: unknown) => void = () => ({});

  // When the value in the UI is changed, this method will invoke a callback function
  registerOnChange(fn: (_: unknown) => void) {
    this.onChange = fn;
  }

  // When the element is touched, this method will get called
  registerOnTouched(fn: (_: unknown) => void) {
    this.onTouch = fn;
  }
}
